import React from "react";
import Breakpoint from "util/responsive/breakpoint";
export default function TabletBreakpoint(props) {
  return <Breakpoint name="tablet">{props.children}</Breakpoint>;
}
